import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

@Component({
  selector: 'umss-marker',
  standalone: true,
  imports: [CommonModule, UmssTooltipDirective],
  templateUrl: './marker.component.html',
  styleUrls: ['./marker.component.scss']
})
export class UmssMarkerComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** State props */
  @Input() state: 'Regular' | 'Focus' = 'Regular';
  @Input() disabled: boolean = false;
  @Input() tooltip: string = '';
}
